<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Subcategories"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right">
            <div class="course-search">
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path
                        d="m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                    ></path>
                </svg>

                <input
                    type="search"
                 
                    (ngModelChange)="onSearchChange()"
                    placeholder="Search subcategories..."
                    aria-label="Search subcategories"
                />

                <span class="search-shortcut">
                    Ctrl + K
                </span>
            </div>

            <button
                type="button"
                class="add-course-button"
                (click)="addSubcategory()"
            >
                <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path d="M12 5v14M5 12h14"></path>
                </svg>

                <span>Add Subcategory</span>
            </button>
        </div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div
                class="table-responsive"
                *ngIf="
                    filteredSubcategories.length > 0;
                    else noSubcategories
                "
            >
                <table class="course-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Total Course</th>

                            <th class="action-column">
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            *ngFor="
                                let subcategory of paginatedSubcategories;
                                trackBy: trackBySubcategoryId
                            "
                        >
                            <td data-label="Name">
                                <div class="course-title-group">
                                    <h3>
                                        {{ subcategory.name }}
                                    </h3>
                                </div>
                            </td>

                            <td data-label="Category">
                                <span class="subcategory-text">
                                    {{ subcategory.category }}
                                </span>
                            </td>

                            <td data-label="Total Course">
                                <span>
                                    {{ subcategory.totalCourses }}
                                </span>
                            </td>

                            <td
                                class="action-column"
                                data-label="Action"
                            >
                                <div
                                    ngbDropdown
                                    class="d-inline-block action-dropdown"
                                    container="body"
                                >
                                    <button
                                        type="button"
                                        class="btn btn-outline-primary"
                                        [id]="
                                            'subcategoryActions' +
                                            subcategory.id
                                        "
                                        ngbDropdownToggle
                                        aria-label="Subcategory actions"
                                    >
                                        <i
                                            class="fa fa-ellipsis-v"
                                            aria-hidden="true"
                                        ></i>
                                    </button>

                                    <div
                                        ngbDropdownMenu
                                        [attr.aria-labelledby]="
                                            'subcategoryActions' +
                                            subcategory.id
                                        "
                                        class="dp-items"
                                    >
                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            (click)="
                                                editSubcategory(
                                                    subcategory
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/edit.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Edit
                                        </button>

                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            class="text-danger"
                                            (click)="
                                                deleteSubcategory(
                                                    subcategory
                                                )
                                            "
                                        >
                                            <img
                                                src="../assets/img/delete.svg"
                                                class="h-4 mr-2"
                                                alt=""
                                            />

                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ng-template #noSubcategories>
                <div class="empty-state">
                    <div>
                        <img
                            src="../../../../assets/img/no-data.svg"
                            class="h-64"
                            alt="No subcategories"
                        />
                    </div>

                    <h3>No data found</h3>

                    <p>
                        Try changing the subcategory search
                        text.
                    </p>

                    <button
                        type="button"
                        class="clear-filter-button"
                        (click)="clearFilters()"
                    >
                        Clear filters
                    </button>
                </div>
            </ng-template>

            <!-- Pagination -->
            <div
                class="table-footer"
                *ngIf="filteredSubcategories.length > 0"
            >
                <div class="pagination-summary">
                    Showing
                    <strong>{{ startItem }}</strong>
                    –
                    <strong>{{ endItem }}</strong>
                    of
                    <strong>
                        {{ filteredSubcategories.length }}
                    </strong>
                    subcategories
                </div>

                <div class="pagination-container">
                    <ngb-pagination
                        [(page)]="page"
                        [pageSize]="pageSize"
                        [collectionSize]="
                            filteredSubcategories.length
                        "
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="true"
                        [boundaryLinks]="false"
                        [directionLinks]="true"
                        aria-label="Subcategory pagination"
                    >
                    </ngb-pagination>
                </div>

                <div class="page-size-control">
                    <label for="subcategoryPageSize">
                        Rows per page
                    </label>

                    <select
                        id="subcategoryPageSize"
                        [value]="pageSize"
                        (change)="onPageSizeChange($event)"
                    >
                        <option value="5">5</option>
                        <option value="8">8</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
            </div>
        </section>
    </div>
</div>